import { SettingModel } from './setting.model';

export class SettingFactory {
  public static new(data?: Partial<SettingModel>): SettingModel {
    return new SettingModel(data);
  }

  public static getModel(): any {
    return SettingModel;
  }

  public static getPath(): string {
    return 'settings';
  }
}
